export default {
  'zh-CN': {
    registerHelp: {
      title: '为什么收不到验证邮件',
      intro: '如果您没有收到 Fuzozo 的验证邮件，请按以下方式排查：',
      items: [
        '请确认邮箱是否设置垃圾邮件自动过滤，可进入垃圾箱查找含“Fuzozo”发送的邮件。',
        '请确认“Fuzozo”的邮件地址是否被列入了黑名单，可将“Fuzozo”的邮件地址：noreply@mail.fuzozo.net 从黑名单移除。',
        '请确认绑定安全邮箱是否为可用状态，若绑定邮箱已经注销停用，需要手动更换邮箱。',
        '以上原因均未出现，可能是“Fuzozo”的邮件地址被企业邮件服务器拦截，请联系企业邮箱管理员。'
      ]
    }
  },
  en: {
    registerHelp: {
      title: 'Why did I not receive the verification email?',
      intro: 'If you have not received a verification email from Fuzozo, please check the following:',
      items: [
        'Check whether your mailbox automatically filters spam. You can search the spam or junk folder for emails sent by “Fuzozo”.',
        'Check whether the Fuzozo email address is on your blacklist. If it is, remove noreply@mail.fuzozo.net from the blacklist.',
        'Confirm that your bound security email address is still active. If the bound mailbox has been closed or disabled, you need to change the email address manually.',
        'If none of the above applies, the Fuzozo email address may have been blocked by your company mail server. Please contact your enterprise email administrator.'
      ]
    }
  },
  ja: {
    registerHelp: {
      title: '確認メールが届かない場合',
      intro: 'Fuzozo からの確認メールが届かない場合は、以下をご確認ください。',
      items: [
        '迷惑メールの自動振り分けが設定されていないか確認してください。迷惑メールフォルダで「Fuzozo」から送信されたメールを検索できます。',
        'Fuzozo のメールアドレスがブラックリストに登録されていないか確認してください。登録されている場合は、noreply@mail.fuzozo.net をブラックリストから削除してください。',
        '登録済みのセキュリティメールアドレスが利用可能な状態か確認してください。メールアドレスが解約または停止されている場合は、手動でメールアドレスを変更する必要があります。',
        '上記に該当しない場合、Fuzozo のメールアドレスが企業メールサーバーによりブロックされている可能性があります。企業メール管理者にお問い合わせください。'
      ]
    }
  },
  'zh-TW': {
    registerHelp: {
      title: '為什麼收不到驗證郵件',
      intro: '如果您沒有收到 Fuzozo 的驗證郵件，請依照以下方式排查：',
      items: [
        '請確認信箱是否設定垃圾郵件自動過濾，可進入垃圾信件匣查找由「Fuzozo」寄送的郵件。',
        '請確認「Fuzozo」的郵件地址是否被列入黑名單，可將「Fuzozo」的郵件地址 noreply@mail.fuzozo.net 從黑名單移除。',
        '請確認綁定的安全信箱是否仍可使用；若綁定信箱已註銷或停用，需要手動更換信箱。',
        '若以上原因皆未出現，可能是「Fuzozo」的郵件地址被企業郵件伺服器攔截，請聯絡企業信箱管理員。'
      ]
    }
  }
}
